// extracted by mini-css-extract-plugin
export default {"tableOverflow":"styles_tableOverflow__cnE53","table":"styles_table__Np2rB"};